// extracted by mini-css-extract-plugin
module.exports = {"ContentTitle":"ContentTitle-module--ContentTitle--3efq0"};